import styled from 'styled-components';
import { InputRadioStyled } from '../InputRadioStyled';

export const InputRadioStyledAP = styled(InputRadioStyled)``;
